import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'Components/UI/Icon';
import { childNodes } from 'Helpers/PropTypes';
import classNames from 'classnames';

import './index.css';
import { withStyles } from '@material-ui/core/styles';

const styles = {
  iconWrapper: {
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #52b4e5',
    borderRadius: '19px',
    lineHeight: '18px',
    marginRight: '28px',
    padding: '9px',
  },
};

const IconField = ({
  classes, children, className, icon, ...props
}) => (
  <div {...props} className={`IconField ${className}`.trim()}>
    <span className={classNames(classes.iconWrapper)}>
      <Icon icon={icon} />
    </span>
    {children}
  </div>
);

IconField.propTypes = {
  children: childNodes,
  className: PropTypes.string,
  icon: PropTypes.string.isRequired,
};

IconField.defaultProps = {
  children: undefined,
  className: '',
};

export default withStyles(styles)(IconField);
